import { FC, ReactNode } from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";

interface IModernInfoItem {
  icon?: ReactNode;
  label: string;
  value: string | number | undefined | null;
  fullWidth?: boolean;
}

export const ModernInfoItem: FC<IModernInfoItem> = ({
  icon,
  label,
  value,
  fullWidth = false,
}) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  if (!value && value !== 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        minWidth: fullWidth ? "100%" : { xs: "140px", sm: "180px" },
        flex: fullWidth ? 1 : "none",
      }}
    >
      {icon && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: alpha(primaryColor, 0.1),
            color: primaryColor,
            flexShrink: 0,
            "& svg": { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontSize: { xs: "11px", sm: "12px" },
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: 0.5,
            display: "block",
            mb: 0.25,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.primary",
            fontWeight: 500,
            fontSize: { xs: "13px", sm: "14px" },
            wordBreak: "break-word",
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};
